import { useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ContainedButton, OutlinedButton } from 'components/Button';
import { AddIcon } from 'components/Table/Table.css';
import { returnRoleInclusion } from 'utils/helpers/';
import { useToggleState } from 'utils/hooks/useToggleState';
import { RoleTypes } from 'utils/rolesTypes';
import BusinessTripCalculator from './Screens/BusinessTripCalculator';
import { TripCalculatorContext } from './Screens/BusinessTripCalculator/TripCalculatorContext';
import { ActionKind } from './Screens/BusinessTripCalculator/TripCalculatorContext/types';
import BusinessTripFilterBar from './BusinessTripFilterBar';
import { BusinessTripBoxProps } from './types';

const BusinessTripBox = ({
  onAddBusinessTrip,
  roles,
  filterBar,
}: BusinessTripBoxProps) => {
  const intl = useIntl();
  const [showCalculator, handleToggleCalculator] = useToggleState(false);
  const { dispatch } = useContext(TripCalculatorContext);

  const isAccounting = useMemo(
    () =>
      returnRoleInclusion(roles, [
        RoleTypes.RoleDEVHR,
        RoleTypes.RoleAccounting,
      ]),
    [roles],
  );

  const handleEmptyCalculatorClick = () => {
    dispatch({
      type: ActionKind.SetIsEmptyCalculation,
      payload: { isEmptyCalculation: true },
    });
    handleToggleCalculator();
  };

  const actions = (
    <>
      {isAccounting && (
        <OutlinedButton color="default" onClick={handleEmptyCalculatorClick}>
          {intl.formatMessage({
            id: 'BUSINESS_TRIP.EMPTY_CALCULATOR_BUTTON',
          })}
        </OutlinedButton>
      )}
      <ContainedButton endIcon={<AddIcon />} onClick={onAddBusinessTrip}>
        {intl.formatMessage({
          id: 'BUSINESS_TRIP.ADD',
        })}
      </ContainedButton>
    </>
  );

  return (
    <>
      <BusinessTripFilterBar {...filterBar} actions={actions} />
      {showCalculator && (
        <BusinessTripCalculator
          showCalculator={showCalculator}
          handleToggleCalculator={handleToggleCalculator}
        />
      )}
    </>
  );
};

export default BusinessTripBox;
